import { ManagerName } from 'src/models/managerCluster';

export const getFullName = (name: ManagerName, isOwnVacancies = false, ownName = ''): string => {
    if (isOwnVacancies) {
        return ownName;
    }

    return `${name.lastName} ${name.firstName} ${name.middleName || ''}`;
};
